import type { FC, SVGProps } from "react";

/** The edge of Figma's largest InstitutionIcon variant, in px. */
export const FIGMA_VARIANT_SIZE = 40;

/** A glyph-box length as a percentage of the icon, so it scales to every size. */
export const toGlyphPercent = (value: number) =>
    `${(value / FIGMA_VARIANT_SIZE) * 100}%`;

/** Where a glyph sits inside Figma's 40px variant, in px; scaled to every size. */
export interface InstitutionGlyphBox {
    x: number;
    y: number;
    width: number;
    height: number;
}

/**
 * A logo drawn with fixed brand colours (an image URL), or one painted by a
 * token (an inline SVG whose ink follows `color`).
 */
export type InstitutionGlyph =
    | { src: string }
    | { Glyph: FC<SVGProps<SVGSVGElement>>; color: string };

/** One catalogue brand: a glyph on a circular container, as in Figma. */
export interface InstitutionArtwork {
    /** Display name, as the brand writes it. */
    name: string;
    /** Container fill: a token `var(...)` or a brand hex. Omitted when nothing shows behind the glyph. */
    background?: string;
    glyph: InstitutionGlyph;
    /** Omitted when the glyph covers the whole circle. */
    box?: InstitutionGlyphBox;
}
